<template>
  <div class="breadcrumbs">
    <ul>
      <li>
        <router-link class="back-link"
          v-if="hasPrevious()"
          :to="{ path: $routerHistory.previous().path }">
          <span  class="breadcrumbs__separator">&lt;</span> {{ $t('common.breadcrumbs_back_text') }}
        </router-link>
      </li>
      <li v-for="(route, index) in fullPath" :key="route.path">
        <template v-if="index + 1 < fullPath.length">
          <router-link :to="{name: route.name}">
            {{ route.meta.pageName }}
          </router-link>
          <span  class="breadcrumbs__separator">&gt;</span>
        </template>
        <span v-else>{{ route.meta.pageName }}</span>
      </li>
      <li v-if="$route.meta.addBreadcrumb">
        <span  class="breadcrumbs__separator">&gt;</span>
        <template v-if="$route.meta.breadcrumbType === 'org'">
          <dep-name :orgId="$route.params.orgId||$route.query.parent" as-link></dep-name>
        </template>
      </li>
    </ul>
  </div>
</template>
<script>
  export default {
    data () {
      return {
        fullPath: [],
        mainPage: true
      }
    },
    methods: {
      getFullPath () {
        this.fullPath = this.$route.matched;
      },
      hasPrevious () {
        if (this.$routerHistory.hasPrevious() && this.$routerHistory.previous().path !== '/login') {
          return true
        } else {
          return false
        }
      }
    },
    mounted () {
      this.getFullPath()
      this.$bus.$on('pathChanged', () => {
        this.$nextTick(function () {
          this.getFullPath()
        })
      })
    }
  }
</script>
<style lang="scss">
@import 'src/assets/sass/paper/variables';
.breadcrumbs {
  margin-bottom: 25px;
  font-size: 12px;
  color: #A6A6A6;

  .back-link{
    margin-right: 30px;color: #1989FA;
  }
  ul {
    list-style-type: none;
    margin: 0;
    padding: 0;
  }

  li {
    display: inline-block;

    a {
      color: inherit;

      &:hover {
        color: $link-color;
      }
    }
  }

  &__separator {
    margin: 0 10px;
  }
}
</style>